import _defineProperty from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { __rest } from "tslib";
import * as React from 'react';
import cssVar from '@patternfly/react-tokens/dist/js/c_background_image_BackgroundImage';
import cssVarName2x from '@patternfly/react-tokens/dist/js/c_background_image_BackgroundImage_2x';
import cssVarNameSm from '@patternfly/react-tokens/dist/js/c_background_image_BackgroundImage_sm';
import cssVarNameSm2x from '@patternfly/react-tokens/dist/js/c_background_image_BackgroundImage_sm_2x';
import cssVarNameLg from '@patternfly/react-tokens/dist/js/c_background_image_BackgroundImage_lg';
import cssVarNameFilter from '@patternfly/react-tokens/dist/js/c_background_image_Filter';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/BackgroundImage/background-image';
var defaultFilter = React.createElement("filter", null, React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 0 0 0 1 0"
}), React.createElement("feComponentTransfer", {
  colorInterpolationFilters: "sRGB",
  result: "duotone"
}, React.createElement("feFuncR", {
  type: "table",
  tableValues: "0.086274509803922 0.43921568627451"
}), React.createElement("feFuncG", {
  type: "table",
  tableValues: "0.086274509803922 0.43921568627451"
}), React.createElement("feFuncB", {
  type: "table",
  tableValues: "0.086274509803922 0.43921568627451"
}), React.createElement("feFuncA", {
  type: "table",
  tableValues: "0 1"
})));
var filterCounter = 0;
export var BackgroundImage = function BackgroundImage(_a) {
  var _style;

  var className = _a.className,
      src = _a.src,
      _a$filter = _a.filter,
      filter = _a$filter === void 0 ? defaultFilter : _a$filter,
      props = __rest(_a, ["className", "src", "filter"]);

  var getUrlValue = function getUrlValue(size) {
    if (typeof src === 'string') {
      return "url(".concat(src, ")");
    } else if (typeof src === 'object') {
      return "url(".concat(src[size], ")");
    }

    return '';
  };

  var filterId = "patternfly-background-image-filter-overlay".concat(filterCounter++);
  var style = (_style = {}, _defineProperty(_style, cssVar.name, getUrlValue('xs')), _defineProperty(_style, cssVarName2x.name, getUrlValue('xs2x')), _defineProperty(_style, cssVarNameSm.name, getUrlValue('sm')), _defineProperty(_style, cssVarNameSm2x.name, getUrlValue('sm2x')), _defineProperty(_style, cssVarNameLg.name, getUrlValue('lg')), _defineProperty(_style, cssVarNameFilter.name, "url(#".concat(filterId, ")")), _style);
  return React.createElement("div", Object.assign({
    className: css(styles.backgroundImage, className),
    style: style
  }, props), React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "pf-c-background-image__filter",
    width: "0",
    height: "0"
  }, React.cloneElement(filter, {
    id: filterId
  })));
};